import { AUTHUSER_QUERY_PARAM } from "@verbleif/shared/src/composables/AccountsStore/useAccountsStore";
import { useAuthStore } from "@verbleif/shared/src/composables/AuthStore/useAuthStore";
import { createWebAutomationRoutes } from "@verbleif/shared/src/composables/Automation/automationRoutes";
import { useLocationStore } from "@verbleif/shared/src/composables/LocationStore/useLocationStore";
import AuthRoutes from "@web/features/Auth/AuthRoutes";
import PublicRoutes from "@web/features/Public/PublicRoutes";
import ReportRoutes from "@web/features/Reports/ReportsRoutes";
import ReservationsRoutes from "@web/features/Reservations/ReservationsRoutes";
import SettingsRoutes from "@web/features/Settings/SettingsRoutes";
import TaskRoutes from "@web/features/Tasks/TasksRoutes";
import Gleap from "gleap";
import { createRouter, createWebHistory } from "vue-router";

const routes = [
  ...SettingsRoutes,
  ...AuthRoutes,
  ...TaskRoutes,
  ...ReportRoutes,
  ...ReservationsRoutes,
  ...createWebAutomationRoutes(() => import("@verbleif/shared/src/composables/Automation/AutomationContainer.vue")),
  ...PublicRoutes,
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});
export default router;

const { returnUrl, hasToken, isRemembered } = useAuthStore();
const locationStore = useLocationStore();

router.beforeEach((to) => {
  // The tab's account was resolved from this query when `useAccountsStore` was instantiated on
  // import; from here on the session mirror is the truth, so the URL drops it.
  if (typeof to.query[AUTHUSER_QUERY_PARAM] === "string") {
    const { [AUTHUSER_QUERY_PARAM]: _authuser, ...query } = to.query;
    return { path: to.path, query, hash: to.hash, replace: true };
  }

  if (to.meta.skipAuthChecks) {
    return true;
  }

  const isUnauthenticated = !hasToken.value && !isRemembered.value;
  if (isUnauthenticated && !to.meta.public) {
    returnUrl.value = to.fullPath;
    return { name: "login" };
  }

  const isAuthenticated = hasToken.value || isRemembered.value;

  const wantsToGoToSpaces = to.name === "spaces";
  const skipLocationCheck = to.meta.skipLocationCheck;

  if (isAuthenticated) {
    if (!wantsToGoToSpaces && !skipLocationCheck) {
      if (!locationStore.selectedLocation.value) {
        return { name: "spaces" };
      }
    }
  }

  if (to.fullPath === returnUrl.value) {
    returnUrl.value = null;
  }

  return true;
});

// Track page views in Gleap after every successful navigation
router.afterEach((to) => {
  const isAuthenticated = hasToken.value || isRemembered.value;

  // Avoid issues in non-browser/test environments
  if (typeof window === "undefined" || !isAuthenticated) {
    return;
  }

  try {
    const pageName = to.name ? to.name.toString() : to.path;
    Gleap.trackEvent("pageView", {
      page: pageName,
    });
  } catch (error) {
    // Do not block navigation on telemetry failures
    console.error("Gleap pageView tracking failed", error);
  }
});
